export default __webpack_public_path__ + "static/media/example-product3.7362cae1.jpeg";